import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Menu, Dropdown, Button} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import {useInternationalization} from '@/contexts/InternationalizationContext';
import map from 'lodash/map';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
import {ReactComponent as Translate} from './translate.svg';
import {getMountedLanguages} from '@/utils/mountedLanguages';

export const LangItem = ({value}) => {
  const {t} = useTranslation('locales');

  return t(value);
};

LangItem.propTypes = {
  value: PropTypes.any,
};

export const LanguageSelectComponent = ({value, onChange, ...props}) => {
  const mountedLanguages = useMemo(getMountedLanguages, []);

  const menu = useMemo(() => (
    <Menu onClick={({key}) => onChange(key)}>
      {
        map(mountedLanguages, (lang) => (
          <Menu.Item key={lang} className={classNames('px-4', {'text-primary': lang === value})}>
            <LangItem value={lang}/>
          </Menu.Item>
        ))
      }
    </Menu>
  ), [value, mountedLanguages, onChange]);

  return (
    <Dropdown overlay={menu} trigger="click">
      <Button
        className="pl-2"
        icon={<span className="anticon anticon-control opacity-50"><Translate/></span>}
        {...props}
      >
        {value.toUpperCase()} <DownOutlined/>
      </Button>
    </Dropdown>
  );
};

LanguageSelectComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const LanguageSelect = (props) => {
  const {locale, updateLocale} = useInternationalization();

  return <LanguageSelectComponent value={locale} onChange={updateLocale} {...props}/>;
};

export default memo(LanguageSelect);
